import { type NavItemType } from './nav-api';

export const navItemType = {
  ACCORDION: 'ACCORDION',
  LINK: 'LINK',
  ALL_SPORTS_EXPANDABLE: 'ALL_SPORTS_EXPANDABLE',
  FEATURED_LINKS: 'FEATURED_LINKS',
  HAMBURGER: 'HAMBURGER',
  LINK_GROUP: 'LINK_GROUP',
  GROUP: 'GROUP',
  SPLIT_EXPANDABLE: 'SPLIT_EXPANDABLE',
  FLAT_ITEMS_EXPANDABLE: 'FLAT_ITEMS_EXPANDABLE',
  MY_ACCOUNT: 'MY_ACCOUNT',
  LOGO: 'LOGO',
  ODDS_FORMAT: 'ODDS_FORMAT',
  BETSLIP: 'BETSLIP',
  HEADING: 'HEADING',
  NESTED: 'NESTED',
  TOOLS: 'TOOLS',
  STATE_SELECTOR: 'STATE_SELECTOR',
} as const satisfies Record<NavItemType, NavItemType>;

export const navItemsType = {
  PROMO_CODE: 'PROMO_CODE',
} as const;

export const variant = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
} as const;

export type Variant = (typeof variant)[keyof typeof variant];

export const footerItemType = {
  APP: 'APP',
  DISCLAIMER: 'DISCLAIMER',
  LOGO: 'LOGO',
} as const;

export type FooterItemType = (typeof footerItemType)[keyof typeof footerItemType];
